import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthSession } from '@features/shared/auth/domain/models/auth-session.model';
import { AuthMapper } from '@features/shared/auth/data/mappers/auth.mapper';
import { StaffClinic } from '../../domain/models/staff-clinic.model';
import { IStaffClinicsRepository } from '../../domain/repositories/staff-clinics.repository';
import { StaffClinicsRemoteDatasource } from '../datasources/remote/staff-clinics.remote-datasource';
import { StaffClinicMapper } from '../mappers/staff-clinic.mapper';

@Injectable()
export class StaffClinicsRepositoryImpl implements IStaffClinicsRepository {
  private readonly datasource = inject(StaffClinicsRemoteDatasource);
  private readonly mapper = inject(StaffClinicMapper);
  // Reused rather than duplicated: a clinic switch's response is the exact same `TokenResponseDto`
  // shape a login answers with, so it is turned into an `AuthSession` the same way.
  private readonly authMapper = inject(AuthMapper);

  public list(): Observable<StaffClinic[]> {
    return this.datasource.list().pipe(map((dtos) => dtos.map((dto) => this.mapper.toStaffClinic(dto))));
  }

  public switchClinic(clinicId: number, refreshToken: string): Observable<AuthSession> {
    return this.datasource.switchClinic(clinicId, refreshToken).pipe(map((dto) => this.authMapper.toSession(dto)));
  }

  public setDefault(clinicId: number): Observable<void> {
    return this.datasource.setDefault(clinicId);
  }

  public acceptInvitation(invitationId: string): Observable<void> {
    return this.datasource.acceptInvitation(invitationId).pipe(map(() => undefined));
  }

  public rejectInvitation(invitationId: string): Observable<void> {
    return this.datasource.rejectInvitation(invitationId);
  }
}
